import { render, staticRenderFns } from "./ServiceEntitySelector.vue?vue&type=template&id=48a64d74"
import script from "./ServiceEntitySelector.vue?vue&type=script&lang=js"
export * from "./ServiceEntitySelector.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports